import React, { useEffect } from "react";
import Container from "components/Container";
import customizedTheme from "styles/theme";
import { ThemeProvider } from "@mui/material/styles";
import { StyledEngineProvider } from "@mui/material";
import { CssBaseline } from "@mui/material";
import { Security } from "@okta/okta-react";
import oktaAuth from "oktaAuth";
import { useNavigate } from "react-router-dom";
import { toRelativeUrl } from "@okta/okta-auth-js";

function App() {
  const navigate = useNavigate();

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  useEffect(() => {
    const environment = window.env.REACT_APP_ENVIRONMENT;
    if (!environment || environment === "Prod") {
      document.title = "POET";
    } else {
      document.title = "POET - " + environment;
    }
  }, []);

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <ThemeProvider theme={customizedTheme}>
        <StyledEngineProvider injectFirst>
          <CssBaseline />
          <Container />
        </StyledEngineProvider>
      </ThemeProvider>
    </Security>
  );
}

export default App;
